import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./styles/theme";
import { Helmet } from "react-helmet-async";

// Import Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Lazy load pages
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Contact = lazy(() => import("./pages/Contact"));

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Helmet>
          {/* Primary Title and Meta */}
          <title>Evan Barbers | Your Trusted Grooming Destination</title>
          <meta
            name="description"
            content="Evan Barbers offers premium men's grooming services. Find us at Grand Drive and Wimbledon locations."
          />
          <meta
            name="keywords"
            content="Barbers, Grooming, Haircuts, London Barbers, Men's Grooming"
          />
          <meta name="author" content="Evan Barbers" />

          {/* Canonical URL */}
          <link rel="canonical" href="https://www.evanbarbers.org/" />

          {/* JSON-LD Structured Data */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Barbershop",
              name: "Evan Barbers",
              image: "https://www.evanbarbers.org/evanbarbers/logo.webp",
              address: {
                "@type": "PostalAddress",
                streetAddress: "358 Grand Drive, SW20 9NQ",
                addressLocality: "London",
                addressRegion: "London",
                postalCode: "SW20 9NQ",
                addressCountry: "UK",
              },
              url: "https://www.evanbarbers.org",
              telephone: "+44 7928 186951",
              openingHoursSpecification: [
                {
                  "@type": "OpeningHoursSpecification",
                  dayOfWeek: [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                  ],
                  opens: "09:00",
                  closes: "19:00",
                },
                {
                  "@type": "OpeningHoursSpecification",
                  dayOfWeek: "Sunday",
                  opens: "10:00",
                  closes: "17:00",
                },
              ],
            })}
          </script>
        </Helmet>
        <ScrollToTop />
        <Navbar />
        <Suspense
          fallback={
            <div style={{ textAlign: "center", padding: "20px" }}>
              Loading...
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            {/* Redirect unknown routes to Home */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
        <Footer />
      </Router>
    </ThemeProvider>
  );
};

export default App;
